import { FRONTEND_STATE_MAP_INITIALIZATION_FAILED_SET } from './mapInitializationFailed.actionTypes';

export const frontendStateMapInitializationFailedSet = (hasInitializationFailed: boolean) => ({
  type: FRONTEND_STATE_MAP_INITIALIZATION_FAILED_SET,
  payload: {
    hasInitializationFailed,
  },
}) as const;
